// src/components/AddToCartButton.jsx
import React from "react";
import { motion } from "framer-motion";

const AddToCartButton = ({
  onClick,
  children = "Add",
  className = "btn btn-sm btn-primary",
}) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.92 }}
      transition={{ type: "spring", stiffness: 500, damping: 28 }}
      className={className}
      onClick={onClick}
    >
      {children}
    </motion.button>
  );
};

export default AddToCartButton;
